import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function UrgencyCTA() {
  return <section className="py-32 px-6 bg-dark relative overflow-hidden" data-id="element-182">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[100px] pointer-events-none" data-id="element-183"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-184">
        <FadeIn data-id="element-185">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-cream mb-6" data-id="element-186">
            Don't Let Your Memories{' '}
            <span className="text-gold italic" data-id="element-187">Disappear</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-188">
          <p className="text-xl text-cream-dark/80 mb-12 font-light" data-id="element-189">
            Your event happens once. Make sure you capture everything.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-190">
          <div className="flex items-center gap-3 mb-6 justify-center" data-id="element-191">
            <span className="text-cream-dark/50 line-through text-2xl" data-id="element-192">
              $120
            </span>
            <span className="text-gold font-heading text-5xl font-bold" data-id="element-193">
              $79
            </span>
            <span className="bg-gold/20 text-gold text-sm font-semibold px-3 py-1 rounded-full" data-id="element-194">
              SAVE 34%
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-195">
          <Button className="text-xl px-12 py-5 shadow-[0_0_40px_rgba(201,168,76,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] w-full sm:w-auto" data-id="element-196">
            👉 Order Now on Etsy
          </Button>
        </FadeIn>
      </div>
    </section>;
}